// 此文件用来存放一些全局变量
window.global = {};
var domain = document.domain;
// 这边的url 不要带/
if ("localhost" != domain) {

  //这边有一个混淆的地方，生产中这个地址实际上要填写nginx 的地址。不能直接是接口地址
  window.global.remoteServer = 'http://www.eledui.com:9999/api/';
} else {
  window.global.remoteServer = 'http://localhost:8081/';
}



// WEBPACK FOOTER //
// ./src/api/global.js